import axios, { AxiosResponse } from 'axios'

const getChatListUserApi = async ({ id, params }: { id: string | string[]; params: any }): Promise<any> => axios.get(`/communities/${id}/chat_histories`, { params })

const communityChatListServices = {
  getChatListUserApi,
}

export default communityChatListServices
